import PropTypes from "prop-types";
import React from "react";

import SummaryPosition from "./SummaryPosition";

const ApplicationSummaryMismatches = ({ activePIDs, positions, hasSubmittedApps }) => {
    if (positions.length === 0 || hasSubmittedApps) {
        return null;
    }

    const nodes = positions.map((p) => (
        <SummaryPosition key={p.id} position={p} activePIDs={activePIDs} />
    ));

    return (
        <div>
            <div className="app-summary__section app-summary__section--content app-summary__mismatches">
                <header className="app-summary__header">
                    <h1>
                        We&apos;re sorry&mdash;we were unable to apply to the following jobs for you
                    </h1>
                </header>
                <div className="app-summary__positions">{nodes}</div>
            </div>
            <div className="app-summary__section app-summary__mismatches-cta">
                <p>We have other jobs that could be a better fit</p>

                <a className="btn jobs-btn btn-large btn-primary" href="/jobs">
                    View more jobs
                </a>
            </div>
        </div>
    );
};

ApplicationSummaryMismatches.propTypes = {
    activePIDs: PropTypes.arrayOf(PropTypes.number).isRequired,
    positions: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    hasSubmittedApps: PropTypes.bool.isRequired,
};

export default ApplicationSummaryMismatches;
